import bridge from '@vkontakte/vk-bridge';
import { createEffect } from 'effector';
import { IGetImageListRes } from '../../../model/types';

export const getImageListFx = createEffect<string, IGetImageListRes, Error>(async $userAccessToken => {
  try {
    const { response } = await bridge.send(
      'VKWebAppCallAPIMethod',
      {
        method: 'status.getImageList',
        params: {
          v: '5.131',
          access_token: $userAccessToken
        }
      }
    );

    if (!response) {
      throw new Error('Ошибка получения списка статусов');
    }

    return response as IGetImageListRes;
  } catch (error) {
    throw new Error(String(error));
  }
});
